import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Box, Typography, Grid, Container } from "@mui/material";
import { StyledContainer, styles } from "../../components/formStyles";
import { barClubViewRequest } from "../../../redux/barclub/BarClubAction";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../constant/commonButton";
import { useParams } from "react-router-dom";
import "../../../style/style.css";
import ReusableFormFields from "../../constant/reusableFormFields";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import pdf from "../../../image/pdf.jpg";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import ImagePreviewDialog from "../../constant/commonImageDialog";

const ViewClub = () => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
  const [proofPreview, setProofPreview] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [proofSelected, setProofSelected] = useState([]);

  const barClubState = useSelector(
    (state) => state?.barClub?.viewBarClub?.data || {}
  );
  const barClubList = barClubState || [];

  useEffect(() => {
    if (barClubList) {
      setValue("reg_no", barClubList?.reg_no);
      setValue("first_name", barClubList?.first_name);
      setValue("last_name", barClubList?.last_name);
      setValue("address", barClubList?.address);
      setValue("email", barClubList?.email);
      setValue("contact", barClubList?.contact);
      setValue("name", barClubList?.name);
      setValue("google_map_location", barClubList?.google_map_location);
      setValue("latitude", barClubList?.latitude);
      setValue("longitude", barClubList?.longitude);
      setValue("postal_code", barClubList?.postal_code);
      setValue(
        "shop_open_and_close_time",
        barClubList?.shop_open_and_close_time
      );
      const statusLabel =
        barClubList?.status === 1
          ? "Active"
          : barClubList?.status === 0
          ? "Pending"
          : "Inactive";
      setValue("status", statusLabel);

      const imageUrls = Array.isArray(barClubList?.bar_image)
        ? barClubList.bar_image.filter((img) => !!img)
        : barClubList?.bar_image
        ? [barClubList.bar_image]
        : [];

      setImagePreview(imageUrls);

      const proofUrls = Array.isArray(barClubList?.govt_id_image)
        ? barClubList.govt_id_image.filter((img) => !!img)
        : barClubList?.govt_id_image
        ? [barClubList.govt_id_image]
        : [];

      setProofPreview(proofUrls);
    }
  }, [barClubList]);

  useEffect(() => {
    if (id) {
      dispatch(barClubViewRequest(id));
    }
  }, [id, dispatch]);

  const inputFields = [
    {
      name: "reg_no",
      label: "Register No",
      readOnly: true,
    },
    {
      name: "name",
      label: "Name",
      readOnly: true,
    },
    {
      name: "first_name",
      label: "First Name",
      readOnly: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      readOnly: true,
    },
    {
      name: "email",
      label: "Email Address",
      readOnly: true,
    },
    {
      name: "contact",
      label: "Phone No",
      readOnly: true,
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
      readOnly: true,
    },
    {
      name: "google_map_location",
      label: "Google Map Location",
      readOnly: true,
    },
    {
      name: "latitude",
      label: "Latitude",
      readOnly: true,
    },
    {
      name: "longitude",
      label: "Longitude",
      readOnly: true,
    },
    {
      name: "postal_code",
      label: "Postal Code",
      readOnly: true,
    },
    {
      name: "shop_open_and_close_time",
      label: "Shop Open and Close time",
      readOnly: true,
    },
    {
      name: "status",
      label: "Status",
      readOnly: true,
    },
  ];

  const handleCancel = () => {
    navigate(APP_LINKS.BARCLUBAGGREGATION);
  };

  const handleImageClick = (file, isPdf = false) => {
    if (isPdf) {
      window.open(file, "_blank");
    } else if (file !== uploadImage) {
      setSelectedImage(file);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
    setProofSelected(null);
  };

  return (
    <Container>
      <form>
        <Grid container spacing={2}>
          {/* Profile Image Section */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1>View Bar/Club Information </h1>
              </Typography>
            </Box>
            <StyledContainer>
              {(imagePreview || []).map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt="Profile"
                  width={120}
                  height={120}
                  style={styles.image}
                  onClick={() => handleImageClick(image)}
                />
              ))}
            </StyledContainer>
          </Grid>

          {/* Proof Image Section */}
          <Grid item xs={12} sm={6}>
            <Box sx={styles.fileBoxContainer}>
              {/* <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Government ID Proof Image
              </Typography> */}
            </Box>
            <StyledContainer>
              {(proofPreview || []).map((proof, index) => {
                const isPdf = proof.toLowerCase().endsWith(".pdf");

                return (
                  <img
                    key={index}
                    src={isPdf ? pdf : proof}
                    alt="Proof"
                    width={120}
                    height={120}
                    style={styles.image}
                    onClick={() => {
                      if (isPdf) {
                        window.open(proof, "_blank");
                      } else {
                        handleImageClick(proof);
                      }
                    }}
                  />
                );
              })}
            </StyledContainer>
          </Grid>

          {/* Form Fields Section */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />

            {/* Submit and Cancel Buttons */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Back"
                    size="medium"
                    onClick={handleCancel}
                    buttonStyle="StyledButton"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
        proofSelected={proofSelected}
      />
    </Container>
  );
};

export default ViewClub;
